export const MAX_SKILLS_AND_EXPERIENCE_LENGTH = 4000;
